import { isFinite } from "lodash"

import ArticleService from "services/ArticleService"
import { ArticleEquipment, IGetArticleEquipmentDto, IUpdateArticleEquipmentBaseDTO } from "./ArticleEquipment"
import { ArticleType } from "config/constants"

export interface IGetArticleZtsDto extends IGetArticleEquipmentDto {
    descriptionOverwritten?: boolean
}

export interface ICreateArticleZtsDTO {
    articleType: ArticleType
    manufacturerArticleNo: string
}

export interface IUpdateArticleZtsDto extends IUpdateArticleEquipmentBaseDTO {

}

export class ArticleZts extends ArticleEquipment {
    descriptionOverwritten: boolean

    constructor(dto: IGetArticleZtsDto) {
        super(dto)
        this.descriptionOverwritten = dto.descriptionOverwritten || false
    }

    #toCreateDto(): ICreateArticleZtsDTO {
        return {
            articleType: this.articleType,
            manufacturerArticleNo: this.manufacturerArticleNo,
        }
    }

    #toUpdateDto(): IUpdateArticleZtsDto {
        return {
            articleClass: this.articleClass,
            highLevelArticleNumber: this.highLevelArticleNumber,
            lowLevelArticleNumbers: this.lowLevelArticleNumbers,
            measurementSystemId: this.measurementSystemId,
            width: isFinite(this.width) ? this.width : null,
            height: isFinite(this.height) ? this.height : null,
            weight: isFinite(this.weight) ? this.weight : null,
            volume: isFinite(this.volume) ? this.volume : null,
            length: isFinite(this.length) ? this.length : null,
            wheelWidth: isFinite(this.wheelWidth) ? this.wheelWidth : null,
            wheelHeight: isFinite(this.wheelHeight) ? this.wheelHeight : null,
            inch: isFinite(this.inch) ? this.inch : null,
            loadSpeedIndex: this.loadSpeedIndex || null,
            constructionCode: this.constructionCode || null,
            isTubeless: typeof this.isTubeless === "boolean" ? this.isTubeless : null,
            starMarking: isFinite(this.starMarking) ? this.starMarking : null,
            inspectionRequired: this.inspectionRequired,
            quickCouplingSystem: this.quickCouplingSystem,
            connectionType: this.connectionType,
            teeth: this.teeth,
            cuttingEdge: this.cuttingEdge,
            heavyDuty: this.heavyDuty,
            locking: this.locking,
            controlSystem: this.controlSystem,
            agility: this.agility,
            sequence: this.sequence,
        }
    }

    create() {
        return ArticleService.createArticle(this.#toCreateDto())
    }

    async update() {
        if (!this.linkUpdate) {
            throw new Error("Update not allowed")
        }
        await ArticleService.updateArticle(this.linkUpdate, this.#toUpdateDto())
    }
}
